export default function routes() {
  const path = window.location.href

  if (path.includes('find-dealer')) {
    import('../components/dealerLocator')
  }

  if (path.includes('recall')) {
    import('../components/recallLookup').then((module) => module.default())
  }
}
